import script from "./EndPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EndPage.vue?vue&type=script&setup=true&lang=js"

import "./EndPage.vue?vue&type=style&index=0&id=74b6dd6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74b6dd6e"]])

export default __exports__